module.exports = __webpack_public_path__ + "static/img/home-instrument-gliders.0ba6c0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-instrument-gliders.jpg
// module id = sVDA
// module chunks = 1